import { render, staticRenderFns } from "./WizardPages.vue?vue&type=template&id=2f1d6a30&"
import script from "./WizardPages.vue?vue&type=script&lang=js&"
export * from "./WizardPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports